function initAccordionBlockItems() {
  document.querySelectorAll('.accordion-block').forEach((accordionBlock) => {
    const items = accordionBlock.querySelectorAll('.accordion-block__item');
    items.forEach((item) => {
      const head = item.querySelector('.accordion-block__item-head');
      const text = item.querySelector('.accordion-block__item-text');
      head.addEventListener('click', () => {
        const innerText = item.querySelector('.metafield-rich_text_field');
        if (item.classList.contains('accordion-block__item--open')) {
          text.style.height = '0';
          item.classList.remove('accordion-block__item--open');
        } else {
          text.style.height = innerText.offsetHeight + 'px';
          item.classList.add('accordion-block__item--open');
        }
      });
    });
  });
}

function initAccordionBlockPagination() {
  document.querySelectorAll('.accordion-block').forEach((accordionBlock) => {
    const paginationButton = accordionBlock.querySelector('.accordion-block__button--pagination');
    if (paginationButton === null) {
      return;
    }
    paginationButton.addEventListener('click', () => {
      const hiddenItems = accordionBlock.querySelectorAll('.accordion-block__item--pagination-hidden:not(.accordion-block__item--search-hidden)');
      hiddenItems.forEach((hiddenItem, index) => {
        if (index > 5) {
          return false;
        }
        hiddenItem.classList.remove('accordion-block__item--pagination-hidden');
        const newHiddenItems = accordionBlock.querySelectorAll('.accordion-block__item--pagination-hidden:not(.accordion-block__item--search-hidden)');
        if (newHiddenItems.length === 0) {
          paginationButton.classList.add('accordion-block__button--hidden')
        }
      });
    });
  });
}


function initAccordionBlocks() {
  initAccordionBlockItems();
  initAccordionBlockPagination();
}


if (document.readyState !== 'loading') {
  initAccordionBlocks();
} else {
  window.addEventListener('DOMContentLoaded', initAccordionBlocks);
}
